// <rooted-upgrade> swaps one unit of a cart line for the next pack up, in the cart
// drawer and on the cart page. The card is rendered by snippets/rooted-cart-upgrade.liquid.
//
// Order matters: the bigger pack is added first and the old unit removed second, so
// assets/rooted-gift.js never sees a cart that has stopped qualifying for the free tote
// (which would remove the tote and then add it back). The gift reconciler is paused for
// the add, otherwise its tote add races the removal and Shopify drops one of the writes;
// the removal then emits cart:updated and the tote is reconciled once.
(function () {
  if (customElements.get('rooted-upgrade')) return;

  class RootedUpgrade extends HTMLElement {
    connectedCallback() {
      // The cart store replaces markup with innerHTML, which creates a fresh element
      // and calls this again. The flag only stops a moved element binding twice.
      if (this._bound) return;
      this._bound = true;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (button && this.contains(button)) this.upgrade(button);
      });
    }

    async upgrade(button) {
      const store = window.MasterTheme && window.MasterTheme.cart;
      const variantId = Number(this.dataset.variantId);
      const lineKey = this.dataset.lineKey;
      const lineQty = Number(this.dataset.lineQty) || 1;
      if (!store || !variantId || !lineKey) return;
      if (button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      try {
        const item = { id: variantId, quantity: 1 };
        const plan = Number(this.dataset.sellingPlan);
        if (plan) item.selling_plan = plan;

        const gift = window.RootedGift;
        if (gift && gift.pause) gift.pause(true);
        try {
          await store.add([item], { openDrawer: false });
        } finally {
          if (gift && gift.pause) gift.pause(false);
        }
        await store.update({ [lineKey]: Math.max(lineQty - 1, 0) });
      } catch (error) {
        /* The cart store already surfaced the message in a toast. */
      } finally {
        // On success the card has been re-rendered and this button is detached, which is harmless.
        button.setAttribute('aria-busy', 'false');
      }
    }
  }

  customElements.define('rooted-upgrade', RootedUpgrade);
})();
